import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'

import RaisedButton from 'material-ui/RaisedButton'
import DateRange from 'material-ui/svg-icons/action/date-range'
import RemoveCircle from 'material-ui/svg-icons/content/remove-circle'
import CircularProgress from 'material-ui/CircularProgress'

import api from '../../api'
import { setSnackbarMessage } from '../../actions/snackbar'

class EventCalendarControl extends Component<any, any> {
  state = {
    isLoaded: false,
    event: null
  }

  handleAdd = () => {
    const { targetId, targetType } = this.props
// @ts-ignore
    const { target } = this.state
    const body = {
      target_type: targetType,
      target_id: targetId
    }

    if (targetType === 'session_sale') {
      Object.assign(body, {
        start_at: target.pre_registration_start_at || target.open_registration_start_at,
        end_at: target.open_registration_end_at
      })
    } else if (targetType === 'webinar') {
      Object.assign(body, {
        start_at: target.start_at,
        end_at: target.end_at
      })
    }

    api.post('admin/events', { body })
      .then(res => {
        if (res.ok) {
          res.json().then(event => this.setState({ event }))
        }
      })
  }

  handleRemove = () => {
    const { id } = this.state.event
    api.del(`admin/events/${id}`)
      .then(res => {
        if (res.ok) {
          this.setState({ event: null })
        }
      })
  }

  loadTarget () {
    const { targetId, targetType } = this.props
    const targetEndpoint = {
      session_sale: `admin/session_sales/${targetId}`,
      webinar: `admin/webinars/${targetId}`
    }[targetType]

    api.get(targetEndpoint)
      .then(res => res.json())
      .then(target => this.setState({ target }))
  }

  componentWillMount () {
    const { targetId, targetType } = this.props
    const body = {
      'filters[target_type]': targetType,
      'filters[target_id]': targetId
    }

    const loadEvent = api.get('admin/events', { body })
      .then(res => res.json())
      .then(events => this.setState({ event: events[0] || null }))

    Promise.all([this.loadTarget(), loadEvent])
      .then(() => this.setState({ isLoaded: true }))
  }

  render () {
    const { event, isLoaded } = this.state

    if (!isLoaded) {
      return <CircularProgress />
    }

    return (
      <div style={{ marginTop: '1em' }}>
        {!event &&
          <RaisedButton
            label='Add to Event Calendar'
            primary
            icon={<DateRange />}
            onClick={this.handleAdd}
          />}

        {event &&
          <RaisedButton
            label='Remove from Event Calendar'
            primary
            icon={<RemoveCircle />}
            onClick={this.handleRemove}
          />}
      </div>
    )
  }
}

// @ts-ignore
EventCalendarControl.propTypes = {
  targetType: PropTypes.string.isRequired,
  targetId: PropTypes.string.isRequired
}

export default connect(null, { setSnackbarMessage })(EventCalendarControl)
